import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const PageNotFound = () => {
    const { t } = useTranslation()
    return (
        <Box
            style={{ textAlign: 'center' }}
            sx={{
                paddingBottom: 20,
            }}
        >
            <h1>{t('pages.pageNotFound.title')}</h1>
            <p>{t('pages.pageNotFound.message')}</p>
        </Box>
    )
}
